<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4 ms-lg-4">
                <h4>Add Group Charges</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn me-4"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none d-sm-block"
                  type="button"
                  @click:button="BackToGroupCharges()"
                >
                  Back To Group Charges
                </llp-button>
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary  new-btn d-block d-sm-none"
                  @click:button="BackToGroupCharges()"
                  >Go Back
                </llp-button>
              </div>
            </div>
            <div class="row ms-lg-2">
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="confirmPasswordLabel">Group Name:</llp-label>
                <llp-input
                  id="confirmpassword"
                  class="w-100"
                  autocomplete="off"
                  v-model="groupName"
                  :errors="validator.groupName.$errors"
                ></llp-input>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6">
                <llp-label id="role" :aria-label="Role">
                  Select Role:
                </llp-label>
                <select
                  id="status"
                  class="form-control select-dropdown"
                  v-model="selectedRole"
                >
                  <option value="" disabled selected>Select your role</option>
                  <option value="2" v-if="role_id == 1">Admin</option>
                  <option value="4" v-if="role_id == 2">Retailer</option>
                </select>
                <div v-if="validator.selectedRole.$error" class="text-danger">
                  <p>{{ validator.selectedRole.$errors[0].$message }}</p>
                </div>
              </div>
            </div>

            <!-- Dynamic Tab Navigation -->
            <div class="row mt-4 ms-lg-4">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                  <a
                    class="nav-link"
                    :class="{ active: activeTab === tab.name.toLowerCase() }"
                    href="#"
                    @click.prevent="setActiveTab(tab.name.toLowerCase())"
                  >
                    {{ tab.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Dynamic Tab Content -->
            <div class="row mt-3 ms-lg-4">
              <div
                v-for="(tab, index) in tabs"
                :key="'content-' + index"
                v-show="activeTab === tab.name.toLowerCase()"
              >
                <div class="table-responsive col-lg-12 col-md-12 col-sm-12">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Method Type</th>
                        <th>Assign Charges (%)</th>
                        <th v-if="role_id == 2">Charges (%)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(charge, i) in tab.charges" :key="i">
                        <td>{{ charge.name }}</td>

                        <!-- Editable: Assigned Charge -->
                        <td>
                          <llp-input
                            type="text"
                            v-model="charge.assignedCharge"
                            placeholder="Enter assigned charge (%)"
                            :disabled="role_id === '2'"
                          />
                        </td>

                        <!-- Editable: Original Charge -->
                        <td v-if="role_id == 2">
                          <llp-input
                            type="text"
                            v-model="charge.charge"
                            placeholder="Enter charge (%)"
                          />
                          <div
                            class="text-danger mt-1"
                            v-if="
                              validationErrors[tab.name.toLowerCase()] &&
                              validationErrors[tab.name.toLowerCase()][i]
                            "
                          >
                            {{ validationErrors[tab.name.toLowerCase()][i] }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary new-btn"
                @click="save()"
              >
                Save
              </llp-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>
<script>
import NetworkService from "@/services/network.service";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
  setup: () => ({ validator: useVuelidate() }),

  data() {
    return {
      groupName: "",
      selectedRole: "",
      activeTab: "cashfree",
      tabs: [],
      showaddadminSpinner: false,
      validationErrors: {},
      role_id: localStorage.getItem("role_id"),
      user_id: localStorage.getItem("User_id"),
    };
  },
  mounted() {
    this.fetchingCharges();
  },
  validations() {
    return {
      groupName: {
        required: helpers.withMessage("Group name is required.", required),
      },
      selectedRole: {
        required: helpers.withMessage("Role is required.", required),
      },
    };
  },
  methods: {
    BackToGroupCharges() {
      this.$router.push("/charges");
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    async fetchingCharges() {
      try {
        const response = await NetworkService.get(`pg-charges/${this.user_id}`);
        this.tabs = response.data.map((tab) => ({
          ...tab,
          id: tab.id,
          name: tab.name,
          charges: tab.charges.map((charge) => ({
            ...charge,
            id: charge.id,
            name: charge.name,
            type: charge.type,
            assignedCharge: charge.assign_charges  || "",
              charge: charge.charge || ""
          })),
        }));
        if (this.tabs.length > 0) {
          this.activeTab = this.tabs[0].name.toLowerCase();
        }
      } catch (error) {
        this.$refs.toast.show("Unable to fetch the user charges.", "error");
      }
    },

    // async save() {
    //   try {
    //     const isValid = await this.validator.$validate();

    //     if (!isValid) {
    //       // Don't throw, just return early – handled by validationErrors display
    //       return;
    //     }

    //     let hasError = false;
    //     this.validationErrors = {};

    //     // Custom validation: actual charge >= assigned charge
    //     for (const tab of this.tabs) {
    //       const tabErrors = {};
    //       for (let i = 0; i < tab.charges.length; i++) {
    //         const charge = tab.charges[i];
    //         const assigned = parseFloat(charge.assignedCharge);
    //         const actual = parseFloat(charge.charge);

    //         if (!isNaN(assigned) && !isNaN(actual) && actual < assigned) {
    //           tabErrors[i] = "Charges should not be less than assigned charge.";
    //           hasError = true;
    //         }
    //       }

    //       if (Object.keys(tabErrors).length > 0) {
    //         this.validationErrors[tab.name.toLowerCase()] = tabErrors;
    //       }
    //     }

    //     if (hasError) {
    //       // Don't show toast for validation errors
    //       return;
    //     }

    //     const isRoleAdmin = this.role_id === "1";
    //     this.showaddadminSpinner = true;
    //     const payload = {
    //       name: this.groupName,
    //       role_id: this.selectedRole,
    //       user_id: this.user_id,
    //       charges: this.tabs.flatMap((tab) =>
    //         tab.charges.map((charge) => ({
    //           pg_name: tab.name,
    //           pg_id: tab.id,
    //           payment_method: charge.name,
    //           type: charge.type,
    //           ...(isRoleAdmin ? {} : { charge: charge.charge }),
    //         }))
    //       ),
    //     };

    //     await NetworkService.post(
    //       `/store-charges-by-id/${this.user_id}`,
    //       payload
    //     );

    //     if (this.$refs.toast) {
    //       this.$refs.toast.show("Group charges are added successfully.");
    //     }
    //     this.showaddadminSpinner = false;
    //     setTimeout(() => {
    //       this.BackToGroupCharges();
    //     }, 3000);
    //   } catch (err) {
    //     this.showaddadminSpinner = false;
    //     if (this.$refs.toast) {
    //       this.$refs.toast.show("Failed to add group charges.", "error");
    //     }
    //   }
    // },
        async save() {
      try {
        // Validate form fields
        const isValid = await this.validator.$validate();
        if (!isValid) {
          return;
        }

        let hasError = false;
        this.validationErrors = {};

        // Different validation based on user role
        if (this.role_id === "2") {
          // Only admin needs charge validation
          for (const tab of this.tabs) {
            const tabErrors = {};
            for (let i = 0; i < tab.charges.length; i++) {
              const charge = tab.charges[i];
              const assigned = parseFloat(charge.assignedCharge);
              const actual = parseFloat(charge.charge);

              if (!isNaN(assigned) && !isNaN(actual) && actual < assigned) {
                tabErrors[i] = "Charges should not be less than assigned charge.";
                hasError = true;
              }
              
              // Additional validation for empty charge
              if (charge.charge === "" || isNaN(actual)) {
                tabErrors[i] = "Please enter a valid charge percentage.";
                hasError = true;
              }
            }

            if (Object.keys(tabErrors).length > 0) {
              this.validationErrors[tab.name.toLowerCase()] = tabErrors;
            }
          }
        } else if (this.role_id === "1") {
          // Superadmin validation for assigned charges
          for (const tab of this.tabs) {
            const tabErrors = {};
            for (let i = 0; i < tab.charges.length; i++) {
              const charge = tab.charges[i];
              const assigned = parseFloat(charge.assignedCharge);
              
              if (charge.assignedCharge === "" || isNaN(assigned)) {
                tabErrors[i] = "Please enter a valid charge percentage.";
                hasError = true;
              }
            }

            if (Object.keys(tabErrors).length > 0) {
              this.validationErrors[tab.name.toLowerCase()] = tabErrors;
            }
          }
        }

        if (hasError) {
          return;
        }

        this.showaddadminSpinner = true;
        
        // Prepare payload based on user role
        const payload = {
          name: this.groupName,
          role_id: this.selectedRole,
          user_id: this.user_id,
          charges: this.tabs.flatMap((tab) =>
            tab.charges.map((charge) => ({
              pg_name: tab.name,
              pg_id: tab.id,
              payment_method: charge.name,
              type: charge.type,
              charge: this.role_id === "1" ? charge.assignedCharge : charge.charge
            }))
          ),
        };

        await NetworkService.post(`/store-charges-by-id/${this.user_id}`, payload);

        this.$refs.toast.show("Group charges are added successfully.");
        this.showaddadminSpinner = false;
        
        setTimeout(() => {
          this.BackToGroupCharges();
        }, 3000);
      } catch (err) {
        this.showaddadminSpinner = false;
        this.$refs.toast.show(
          err.response?.data?.message || "Failed to add group charges.",
          "error"
        );
      }
    }
  
  },
};
</script>
